import React from 'react';
import { PerformanceSchedulesLineItem } from 'components';

export const LineItemPerformancePage = () => {
    return <PerformanceSchedulesLineItem />;
};
